import BannerTemplate from '../../../component/template/BannerTemplate.js'
import App from "../../../App";
import { reportPV, reportImpressions, reportOfferImpression, onScreenClick } from '@src/common/report'
import { device, getMousePosition, getParams2Native, replaceAppFlyerHost, checkAndroidSDKVersion } from '@src/common/util'
import {onNativeHideCloseButton, onNativeShowCloseButton} from "../../../../api/nativeCalledListener";


export default class DefaultBanner extends BannerTemplate {
    constructor(props) {
        super(props)
        //this.campaign = props.campaign || {}
        this.closeBtnSetAble = true
    }

    adShowed(res) {
        super.adShowed(res)
        // let encodeVideo = window.base64.encodePrivate('https://assets.dspunion.com/cdn-adn/vh/19/02/21/11/21/948e27b8d8571d92db0459076774e49e.mp4')
        // let decodeVIdeo = window.base64.decodePrivate(encodeVideo)
        // console.log('base64编码解码：：：：：========》',encodeVideo,decodeVIdeo )
        // campaign.video_url = `mtg-h5://videoSource?uri=${encodeURIComponent(campaign.video_url)}`
    }

    /**
     * 注册sdk调用设置关闭按钮方法
     */
    registerNativeSetCloseButton(){
        onNativeShowCloseButton((params={}, resolve, reject)=>{
            this.closeBtnSetAble = false
            this.showCloseBtn && this.showCloseBtn().then(()=>{
                resolve()
            }).catch(()=>reject())
        })
        onNativeHideCloseButton((params={}, resolve, reject)=>{
            this.closeBtnSetAble = false
            this.hideCloseBtn && this.hideCloseBtn().then(()=>{
                resolve()
            }).catch(()=>reject())
        })
    }

    /**
     * 初始化banner关闭按钮
     * @param bridgeContext v3返回的数据
     * @param bridgeContext.sdkSetting.dev_close_state ，1表示开发者设置为展示，2表示开发者设置为关闭，0表示开发者未设置
     */
    initBannerCloseBtn(){
        // 如果开发者没有设置过closeButton的显示状态，则默认按setting展示
        console.log('this.closeBtnSetAble ===> ',this.closeBtnSetAble)
        if(!this.closeBtnSetAble){
            return
        }
        console.log("初始化banner关闭按钮")
        console.log('App.initData =======>', App.initData)
        let sdkSettingState = Number(App.initData.sdkSetting.dev_close_state);
        let unitSettingState = Number(App.initData.unitSetting.closeBtn);
        console.log("sdkSettingState",sdkSettingState)
        console.log("unitSettingState",unitSettingState)
        if(sdkSettingState === 1) {
            this.showCloseBtn()
        }else if(sdkSettingState ===2){
            this.hideCloseBtn()
        }else if(unitSettingState === 1){
            this.showCloseBtn()
        }else{
            this.hideCloseBtn()
        }
    }
}